import { queryClient } from '@/shared/api';
import type { VersionCheckResult } from './version-check';
import { VERSION_CHECK_QUERY_KEY } from './version.query-options';

/**
 * 이 실행 버전이 **BE 와 통신하면 안 되는 상태**인가 — 강제 업데이트(native `update-required`) 판정.
 *
 * # 왜 필요한가
 * 강제 업데이트 화면(`/update-required`)은 페이지 자체가 조용해도 **전역 배선이 계속 돈다**. 라우트를
 * 갈아끼워도 `composition` 의 모듈 부수효과(fcm 동기화, 토큰 재발급)는 앱 수명 내내 살아 있어서,
 * 하위호환이 끊긴 구버전이 계속 BE 를 두드린다:
 *   - 부팅 시 auth 복원 → `fcmSync.onAuthenticated()` → `POST /api/v3/auth/fcm`
 *   - 그 요청이 401 이면 → 공통 `refreshToken()` → `POST /api/v3/auth/refresh`
 * 규약이 어긋난 버전이 토큰을 갱신하고 디바이스를 등록하는 건 무의미할 뿐 아니라, 실패 시 세션 종료
 * 판정까지 끌고 들어가 업데이트 화면을 벗어나게 만들 수 있다.
 *
 * # 왜 별도 state 를 안 두나
 * 판정 결과는 이미 버전 체크 query 캐시에 있다. 여기서 **동기 조회**만 해서 쓴다 — 게이트 위젯이 세팅하는
 * 별도 플래그를 두면 "화면 진입"과 "차단 상태"가 갈라져 어긋날 수 있고, 트리 밖(module singleton)에서도
 * 같은 값을 봐야 한다.
 *
 * 캐시가 비었거나(아직 미조회·조회 실패) `web` 이면 **false** — fail-open 이다. 버전 확인이 안 됐다고
 * 앱 기능을 막지 않는다(`versionCheckQueryOptions` 의 실패 정책과 동일).
 */
export function isVersionBlocked(): boolean {
  const result = queryClient.getQueryData<VersionCheckResult>(VERSION_CHECK_QUERY_KEY);
  return result?.platform === 'native' && result.status === 'update-required';
}
